import * as React from "react";
import { motion } from 'framer-motion';

const Path = props => (
  <motion.path
    fill="transparent"
    strokeWidth="3"
    stroke="hsl(0, 0%, 18%)"
    strokeLinecap="round"
    {...props}
  />
);

export const ButtonClose = ({ close, classCss}) => (
  <button onClick={close} className={classCss}>
    <svg width="20" height="20" viewBox="0 0 20 20">
      <Path d="M 3 16.5 L 17 2.5" />
      <Path d="M 3 2.5 L 17 16.346" />
    </svg>
  </button>
);
